import { gql } from '@apollo/client';

const getAllRegistryTokensQueries = gql `
  query (
    $orgID: UUID1!
    $marketplaceID: UUID1
    $owner: String
    $offset: Int
    $limit: Int
    $searchKey: String
    $filters: RegistryTokenFilterInput
    $categoryID: UUID1
    $artistID: UUID1
    $registryID: UUID1
    $buyerAddress: String
    $artistSlug: String
    $categorySlug: String
  ) {
    getAllRegistryTokens(
      orgID: $orgID
      marketplaceID: $marketplaceID
      owner: $owner
      offset: $offset
      limit: $limit
      searchKey: $searchKey
      filters: $filters
      categoryID: $categoryID
      buyerAddress: $buyerAddress
      artistID: $artistID
      registryID: $registryID
      categorySlug: $categorySlug
      artistSlug: $artistSlug
    ) {
      data {
        ID
        TokenName
        TokenID
        Status
        TokenURI
        NFTTokenID
        mediaSourceExtension
        mediaSourceURL
        Price {
          buyNowPrice {
            value
            unit
            type
          }
          lastPurchasedPrice {
            value
            unit
            type
          }
          makeOfferHighestPrice {
            value
            unit
            type
          }
          makeOfferLatestPrice {
            value
            unit
            type
          }
        }
        MetaData {
          name
          image
          description
          animationURL
          openSeaImageURL
        }
        networkID
        latestOffer {
          price {
            value
            unit
            type
          }
        }
        listedOrderInfo {
          id
          listedCurrency {
            contractAddress
          }
          price {
            value
            unit
            type
          }
        }
        isBuyNowEnabled
        isMakeOfferEnabled
        editionNumber
        TokenType
        ListingStatus
        OwnersList
        Owners
        RegistryId
        MintedAt
        TokenOwnerAddress
        nftContractName
        networkName
        Registry {
          ID
          NetworkID
          Network {
            name
          }
          OrganizationID
          CollectionName
          ContractAddress
          IsAllTokensApproved
          MarketplaceID
          TotalApproved
          CollectionTotal
          ArtistID
          Artist {
            id
            description
            artistName
            artistLocation
            artistContactEmail
            artistContactNumber
            artistWebsite
          }
          CategoryID
          CreatedByUserID
          CreatedAt
          UpdatedAt
        }
        Artist {
          id
          description
          artistName
          artistLocation
          artistContactEmail
          artistContactNumber
          artistWebsite
        }
        isOfferExist
        offerOrderId
        CreatedBy
        CreatedAt
        UpdatedAt
        offerOrder {
          id
          nftTokenId
          fixedPrice
          offerExpiryDate
          price {
            value
            unit
            type
          }
        }
      }
      totalCount
      user {
        id
        username
        name
        email
        avatar
      }
      lowestSoldPrice {
        value
        unit
        type
      }
      highestSoldPrice {
        value
        unit
        type
      }
      latestSoldPrice {
        value
        unit
        type
      }
    }
  }
`;

export { getAllRegistryTokensQueries };
